import { Map, List, fromJS } from 'immutable';
import api from '@synergycms_core/utils/api';
import { ParamsParser } from '@synergycms_core/utils';
import { roomCanAddService, boardCanAddService } from './availUtils';
import { AVAIL_LIFETIME } from '../../config/constants';

const setErrorServices = (filteredHotelsIds, paramsQuery, lastRequest) => {
  const result = filteredHotelsIds.reduce(
    (response, hotelId) =>
      response.setIn([hotelId, paramsQuery], Map({ last_request: lastRequest, response: Map({ success: false }) })),
    Map()
  );
  return Promise.resolve(result);
};

export const filterAvailServices = (services = List(), roomRatesSelected) =>
  services.filter(service => {
    let validService = !service.get('has_closed_price');
    if (validService) {
      validService = roomRatesSelected.some(
        block => roomCanAddService(service)(block) && boardCanAddService(service)(block)
      );
    }
    return validService;
  });

export default {
  RESET_AVAIL: () => {
    return (dispatch, getState) => {
      const store = getState();
      return store.getIn(['customer', 'current_hotel']);
    };
  },
  GET_ASYNC: () => {
    return (dispatch, getState) => {
      const store = getState(),
        customerState = store.get('customer'),
        customerSearchParams = customerState.getIn(['params', 'params']),
        serviceSearchParams = Map({
          date: customerSearchParams.get('date'),
          stay_length: customerSearchParams.get('stay_length'),
          daily_details: true
        }),
        paramsQuery = ParamsParser.paramsToQuery(serviceSearchParams);

      if (paramsQuery) {
        let hotelIds;
        if (store.getIn(['customer', 'current_hotel'])) {
          hotelIds = List([store.getIn(['customer', 'current_hotel'])]);
        } else {
          hotelIds = store.getIn(['customer', 'current_hotels']);
        }
        const availability = store.get('availServices');
        const now = +new Date();

        const filteredHotelsIds = List(hotelIds).reduce((hotels, hotelId) => {
          const lastRequest = availability.getIn([hotelId, paramsQuery, 'last_request']);
          if (
            availability.getIn([hotelId, paramsQuery], false) === false ||
            (Number.isFinite(lastRequest) && lastRequest + AVAIL_LIFETIME <= now)
          ) {
            return hotels.push(hotelId);
          }
          return hotels;
        }, List());
        const lastRequest = +new Date();
        if (filteredHotelsIds.size) {
          return api.get('availability/servicesBuscador2', { q: paramsQuery }, filteredHotelsIds.toJS()).then(availResponse => {
              if (availResponse.success !== false) {
                return fromJS(availResponse).reduce(
                  (availServices, services, hotelId) =>
                    availServices.setIn(
                      [hotelId, paramsQuery],
                      Map({
                        last_request: lastRequest,
                        response: services.get('success') === false ? services : services.get(0)
                      })
                    ),
                  Map()
                );
              } else {
                return setErrorServices(filteredHotelsIds, paramsQuery, lastRequest);
              }
            })
            .catch(() => {
              return setErrorServices(filteredHotelsIds, paramsQuery, lastRequest);
            });
        }
        return Promise.resolve();
      }
      return Promise.resolve();
    };
  }
};
